import { API_URL, Minisite_API_TOKEN } from '../../config';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

interface Content {
  type: string;
  text?: string;
  children?: Content[];
}

interface SEO {
  Title: string;
  MetaDescription: string;
  MetaKeywords: string;
  MetaImage: string;
}

interface GA {
  Remarks: string;
  Location: string;
  Code: string;
}

interface MinisiteData {
  id: number;
  Title: string;
  Slug: string;
  Header: boolean;
  Footer: boolean;
  Content: Content[];
  SEO: SEO;
  GA: GA[];
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  locale: string;
}

interface MinisiteResponse {
  data: {
    id: number;
    attributes: MinisiteData;
  }[];
  meta: {
    pagination: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export const fetchMinisite = async (slug: string): Promise<MinisiteResponse> => {
  try {
    console.log(`Fetching minisite with slug: ${slug}`);
    let url = `${API_URL}/minisites?filters[Slug][$eq]=${slug}&populate=*`;
    url = applyPreproductionSettings(url);
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${Minisite_API_TOKEN}`,
      },
    });

    if (!response.ok) {
      console.error(`Error fetching minisite: ${response.statusText}`);
      throw new Error(`Error fetching minisite: ${response.statusText}`);
    }

    const responseData: MinisiteResponse = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error fetching minisite.', error);
    throw error;
  }
};